<template>
  <div class="deptListPage">
    <van-search
      v-model="searchKeyword"
      class="searchBox"
      id="searchHeight"
      placeholder="请输入搜索关键词"
      show-action
      shape="round"
    >
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <div class="list-content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
      >
        <van-checkbox-group v-model="result">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in deptMainList"
              clickable
              :key="item.id"
              :title="`${item.departmentName}`"
              @click="toggle(index, item)"
              class="item"
            >
              <van-checkbox
                :name="item.departmentName"
                ref="checkboxes"
                slot="right-icon"
              />
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </van-list>
    </div>
    <div class="roleBtn clearfix">
      <a href="javascript:void(0);" class="fl" @click="closeDeptPicker">取消</a>
      <a href="javascript:void(0);" class="fl" @click="saveDeptData">确认</a>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
export default {
  name: "deptList",
  data() {
    return {
      searchName: "",
      searchKeyword: "", //搜索的部门id
      total: "", //统计计算
      deptMainList: [],
      deptViewList: [], //部门列表
      result: [], //选择的部门列表
      deptData: [], //选中的部门列表
      cloneRetinuedata: [],
      deptdataList: {},
      retinueIdList: [],
      retinueNameList: "",
      // page: 0,
      // pageSize: 20,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      clientType: "", //手机类型
    };
  },
  props: {
    deptIds: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.getDeptList();
  },
  methods: {
    toggle(index, item) {
      this.$refs.checkboxes[index].toggle();
      this.deptData.push(item);
      this.unique(this.deptData);
    },
    onSearch() {
      let _this = this;
      _this.searchName = _this.searchKeyword;
      _this.reloadPage();
    },
    onCancel() {
      let _this = this;
      this.searchName = "";
      _this.reloadPage();
    },
    getDeptList() {
      let _this = this;

      _this.$api.baseCommon.baseMsg
        .getDeptList({ stationOrgId: _this.searchKeyword })
        .then((res) => {
          if (res.code == "1") {
            _this.deptViewList = res.data;
            _this.viewLists();
            // 加载状态结束
            _this.loading = false;
            _this.finished = true;
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
    viewLists() {
      this.deptMainList = this.deptViewList;
      console.log(this.deptMainList);
      for (let i = 0; i < this.deptIds.length; i++) {
        for (let j = 0; j < this.deptMainList.length; j++) {
          if (this.deptIds[i] == this.deptMainList[j].id) {
            this.result.push(this.deptMainList[j].departmentName);
            this.deptData.push(this.deptMainList[j]);
            this.unique(this.deptData);
          }
        }
      }
      console.log(this.deptData);
    },
    closeDeptPicker() {
      this.deptdataList = "";
      this.$emit("setDeptData", "");
    },
    saveDeptData() {
      let _this = this;
      let arr1 = [];
      let arr2 = [];
      _this.deptData.forEach((item) => {
        arr2.push(item.id);
        arr1.push(item.departmentName);
      });
      _this.retinueNameList = arr1.join("，");
      _this.retinueIdList = arr2;
      _this.deptdataList = {};
      _this.deptdataList.ids = _this.retinueIdList;
      _this.deptdataList.names = _this.retinueNameList;
      this.$emit("setDeptData", _this.deptdataList);

      _this.deptdataList = new Object();
    },
    unique(dataArray) {
      //数组去重
      let _this = this;
      let removeIndex = [];
      dataArray.forEach((item1, index1) => {
        const exist = dataArray.some(
          (item2, index2) => item1.id === item2.id && index1 !== index2
        );
        if (exist) {
          removeIndex.unshift(index1);
        }
      });
      newApi.each(removeIndex, (index) => {
        delete dataArray[index];
      });
      _this.deptData = _this.deptData.filter(function () {
        return true;
      });
    },
    reloadPage() {
      this.deptMainList = [];
      this.loading = false; //是否处于加载状态
      this.finished = false; //是否已加载完所有数据
      this.getDeptList();
    },
  },
};
</script>
<style lang="less" >
.deptListPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .searchBox {
    padding: 0 8px;
    margin-bottom: 10px;
  }
  .list-content {
    height: calc(100% - 95px);
    padding-bottom: 50px;
    overflow: scroll;
    .list-item {
      .item {
        height: 45px;
      }
    }
  }
  .roleBtn {
    position: fixed;
    width: 100%;
    font-size: 0.42667rem;
    text-align: center;
    color: #333;
    height: 45px;
    bottom: 0;
    z-index: 999;
    background-color: #fff;
    border-top: 1px solid #f6f6f6;
    a:first-child {
      color: rgb(235, 199, 155);
      border-right: 1px solid #f6f6f6;
    }
    a {
      display: inline-block;
      width: 50%;
      height: 100%;
      line-height: 45px;
      color: #07c160;
      font-size: 14px;
      box-sizing: border-box;
    }
  }
}
</style>